export const transformSanityTable = (inputObj: any) => {
  const result = []

  if (
    inputObj._type !== 'tableBlock' ||
    !inputObj.table ||
    !Array.isArray(inputObj.table.rows)
  ) {
    // Check if the input object is valid
    throw new Error('Invalid input object format.')
  }

  const rows = inputObj.table.rows

  for (let i = 0; i < rows.length; i++) {
    const row = rows[i]
    if (row._type !== 'tableRow' || !Array.isArray(row.cells)) {
      throw new Error('Invalid row format.')
    }

    const cellData: any = {}
    for (let j = 0; j < row.cells.length; j++) {
      const cellKey = `${inputObj._key}-cell-${j}`
      cellData[cellKey] = row.cells[j]
    }

    result.push(cellData)
  }

  return result
}
